type TurnContext = {
	conversationChannelId?: string;
	chatTurnNumber?: number;
};

export const buildTurnContext = (
	chatSessionId: string | undefined,
	chatTurnNumber: number | undefined,
): TurnContext => {
	const turnContext: TurnContext = {};
	if (chatTurnNumber !== undefined) {
		turnContext.chatTurnNumber = chatTurnNumber;
		if (chatSessionId !== undefined) {
			turnContext.conversationChannelId = chatSessionId;
		}
	}
	return turnContext;
};
